// @ts-nocheck
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../../runtime/json/scalar";
import { WireType, } from "../../../../../runtime/wire/index";
import { default as serialize, } from "../../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, unpackFns, } from "../../../../../runtime/wire/scalar";
import { encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "../../../../google/protobuf/StringValue";
import { default as deserialize, } from "../../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        paymentProviderIds: [],
        appStoreProductId: undefined,
        playStoreProductId: undefined,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    result.paymentProviderIds = value.paymentProviderIds.map(value => tsValueToJsonValueFns.int64(value));
    if (value.appStoreProductId !== undefined)
        result.appStoreProductId = value.appStoreProductId;
    if (value.playStoreProductId !== undefined)
        result.playStoreProductId = value.playStoreProductId;
    return result;
}
export function decodeJson(value) {
    var _a, _b;
    const result = getDefaultValue();
    result.paymentProviderIds = (_b = (_a = value.paymentProviderIds) === null || _a === void 0 ? void 0 : _a.map((value) => jsonValueToTsValueFns.int64(value))) !== null && _b !== void 0 ? _b : [];
    if (value.appStoreProductId !== undefined)
        result.appStoreProductId = value.appStoreProductId;
    if (value.playStoreProductId !== undefined)
        result.playStoreProductId = value.playStoreProductId;
    return result;
}
export function encodeBinary(value) {
    const result = [];
    for (const tsValue of value.paymentProviderIds) {
        result.push([1, tsValueToWireValueFns.int64(tsValue)]);
    }
    if (value.appStoreProductId !== undefined) {
        const tsValue = value.appStoreProductId;
        result.push([2, ((tsValue) => ({ type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }))({ value: tsValue })]);
    }
    if (value.playStoreProductId !== undefined) {
        const tsValue = value.playStoreProductId;
        result.push([3, ((tsValue) => ({ type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }))({ value: tsValue })]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    var _a, _b;
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    collection: {
        const wireValues = wireMessage.filter(([fieldNumber]) => fieldNumber === 1).map(([, wireValue]) => wireValue);
        const value = Array.from(unpackFns.int64(wireValues));
        if (!value.length)
            break collection;
        result.paymentProviderIds = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = (_a = (wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined)) === null || _a === void 0 ? void 0 : _a.value;
        if (value === undefined)
            break field;
        result.appStoreProductId = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = (_b = (wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined)) === null || _b === void 0 ? void 0 : _b.value;
        if (value === undefined)
            break field;
        result.playStoreProductId = value;
    }
    return result;
}
